import '../../styles/restScreens.css';
import React from 'react';

/**
 * BaseWidget Component
 *
 * Base component that all dashboard widgets should extend or use as a wrapper.
 * Provides consistent styling, header, and configuration options.
 */
const BaseWidget = ({
  id,
  title,
  children,
  onRemove,
  onConfigure,
  icon,
  className = '',
  headerActions = null,
  isConfigurable = true,
  isRemovable = true,
  theme = 'light'
}) => {
  return (
    <div data-m6-layout="widgets" data-m6-component="BaseWidget"
      className={`rounded-lg shadow-md p-4 h-full flex flex-col bg-[var(--surface-raised)] ${className}`}
      data-widget-id={id}
    >
      {/* Widget Header */}
      <div className="flex items-center justify-between mb-3 pb-2 border-b border-[var(--surface-border)]">
        <div className="flex items-center space-x-2">
          {icon && (
            <span className="text-[var(--accent-ink)]">
              {icon}
            </span>
          )}
          <h3 className="text-sm font-semibold text-[var(--ink)]">
            {title}
          </h3>
        </div>

        {/* Widget Actions */}
        <div className="flex items-center space-x-1">
          {headerActions}

          {isConfigurable && (
            <button
              onClick={onConfigure}
              className="p-1 transition-colors text-[var(--ink-muted)] hover:text-[var(--ink)]"
              title="Configure widget"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </button>
          )}

          {isRemovable && (
            <button
              onClick={onRemove}
              className="p-1 transition-colors text-[var(--ink-muted)] hover:text-[var(--ui-alert)]"
              title="Remove widget"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>
      </div>

      {/* Widget Content */}
      <div className="flex-1 overflow-auto">
        {children}
      </div>
    </div>
  );
};

export default BaseWidget;
